import { CompositeTitle } from 'av8-ui';
import styled from 'styled-components';

export const StepTitle = styled(CompositeTitle)`
  margin: 1rem 0 2rem 0;
  display: block;
`;